import logo2017 from "../../assets/img/nxtEvents/LogoWarGames/WarGames2017.png";
import logo2018 from "../../assets/img/nxtEvents/LogoWarGames/WarGames2018.png";
import logo2019 from "../../assets/img/nxtEvents/LogoWarGames/WarGames2019.png";
import logo2020 from "../../assets/img/nxtEvents/LogoWarGames/WarGames2020.png";
import logo2021 from "../../assets/img/nxtEvents/LogoWarGames/WarGames2021.png";

export const nxtWarGamesDetail = {
  "nxt-war-games": {
    id: "nxt-war-games",
    title: "NXT WarGames",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-war-games",
        items: [
          {
            id: "nxt-war-games-2017",
            title: "TakeOver: WarGames",
            description: "Houston, We Have A WarGames 2017",
            imgUrl: logo2017,
          },
          {
            id: "nxt-war-games-2018",
            title: "TakeOver",
            description: "WarGames 2018",
            imgUrl: logo2018,
          },
          {
            id: "nxt-war-games-2019",
            title: "TakeOver",
            description: "WarGames 2019",
            imgUrl: logo2019,
          },
          {
            id: "nxt-war-games-2020",
            title: "TakeOver",
            description: "WarGames 2020",
            imgUrl: logo2020,
          },
          {
            id: "nxt-war-games-2021",
            title: "WarGames",
            description: "2021",
            imgUrl: logo2021,
          },
        ],
      },
    ],
  },
};
